module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/vi_shikoku-e9214b00cdf034943e6d0cc216d2bc2d.jpg";